import React from 'react';
import { useFormikContext } from 'formik';
import { Grid, Typography, Box } from '@mui/material';
import { InputField, DatePickerField, SelectField } from '../../FormFields';

const debitTypes = [
  { value: 'Tarjeta de Credito', label: 'Tarjeta de Crédito' },
  { value: 'Tarjeta de Debito', label: 'Tarjeta de Débito' },
  { value: 'Caja de Ahorro', label: 'Caja de Ahorro (solo Banco Provincia)' },
  { value: 'Cta Cte.', label: 'Cuenta Corriente (solo Banco Provincia)' },
];

const cardBrands = [
  { value: 'VISA', label: 'Visa' },
  { value: 'MASTERCARD', label: 'Mastercard' }
];

export default function PaymentForm(props) {
  const { values } = useFormikContext();
  const {
    formField: { debitType, cardBrand, cardNumber, cardExpireFrom, cardExpireTo, cbu, cbuConfirmation }
  } = props;

  return (
    <React.Fragment>
      <Typography variant="h6" gutterBottom>
        Datos del medio de pago
      </Typography>

      <Grid container spacing={3} direction="column">
        <Grid item xs={12}>
          <Typography variant="subtitle1" fontWeight="bold" sx={{ marginBottom: "8px", color: "gray" }}>
            Medio de págo
          </Typography>
          <SelectField
            name={debitType.name}
            data={debitTypes}
            fullWidth
            InputLabelProps={{ shrink: true }}
          />
        </Grid>

        <Grid item xs={12} >
          <Typography variant="subtitle2" component="div">
            <Box fontWeight={550} sx={{ marginBottom: "5px" }}>
              Las opciones de Caja de Ahorro y Cta Cte, sólo están disponibles para los usuarios de Banco Provincia.
            </Box>
          </Typography>
        </Grid>
      </Grid>

      <Grid container spacing={3}>
        {values.debitType === 'Tarjeta de Credito' || values.debitType === 'Tarjeta de Debito' ? (
          <>
            {/* <Grid item xs={12}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ color:"gray"}}>
                Tarjeta
              </Typography>
            </Grid> */}

            <Grid item xs={12} sm={6}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ marginBottom: "8px", color: "gray" }}>
                Tipo Tarjeta
              </Typography>
              <SelectField
                name={cardBrand.name}
                data={cardBrands}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ marginBottom: "8px", color: "gray" }}>
                Número de tarjeta
              </Typography>
              <InputField
                name={cardNumber.name}
                fullWidth
                maxSize={16}
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ marginBottom: "8px", color: "gray" }}>
                Desde:
              </Typography>
              <DatePickerField
                name={cardExpireFrom.name}
                format="MM/yy"
                views={['month', 'year']}
                minDate={new Date('2010/01/01')}
                maxDate={new Date()}
                placeholder="MM/AA"
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ marginBottom: "8px", color: "gray" }}>
                Hasta:
              </Typography>
              <DatePickerField
                name={cardExpireTo.name}
                format="MM/yy"
                views={['month', 'year']}
                placeholder="MM/AA"
                minDate={new Date()}
                maxDate={new Date('2050/12/31')}
                fullWidth
              />
            </Grid>
          </>
        ) : values.debitType && (
          <>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ marginBottom: "8px", color: "gray" }}>
                CBU
              </Typography>
              <InputField
                name={cbu.name}
                maxSize={22}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight="bold" sx={{ marginBottom: "8px", color: "gray" }}>
                Confirmar CBU
              </Typography>
              <InputField
                name={cbuConfirmation.name}
                maxSize={22}
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
          </>
        )}
      </Grid>
    </React.Fragment >
  );
}
